import React, { useState } from 'react'
import { ListGroup } from 'react-bootstrap'
import * as s from './TeamDataPlayersFromLastYear.scss'
import PlayerListItem from '../../Player/PlayerListItem'
import ReturningPlayerContact from './ReturningPlayerContact'

const TeamDataPlayersFromLastYear = ({ missingPlayers = [], seasonName }) => {
    const [contactPlayer, setContactPlayer] = useState(null)

    return (
        <>
        <ListGroup className={s.container}>
        {missingPlayers && missingPlayers.map(p => 
            <PlayerListItem key={`missing-player-${p._id}`} player={p} className={s.item}
                onClick={() => setContactPlayer(p)} tabIndex={0}
                rightDetail={<div className={s.rightContainer}>
                    {p.formattedCellPhone ? <div className={s.cellPhone}>{p.formattedCellPhone}</div> : null}
                    {p.emailAddress ? <div className={s.emailAddress}>{p.emailAddress}</div> : null}
                </div>} />
                    
        )}  
        </ListGroup>
        {contactPlayer ? <ReturningPlayerContact player={contactPlayer} seasonName={seasonName}
            onClose={() => setContactPlayer(null)} /> : null}
        </>
    )
}

export default TeamDataPlayersFromLastYear
